export default __webpack_public_path__ + "assets/images/620409a98f60b12c319e22c8e62021ea.png";